<template>
    <div class="box">
        <div class="box-title" v-if="title">
            <i class="el-icon-s-unfold"></i>
            <span class="inner-title">{{ title }}</span>
            <span class="btns">
        <slot name="btns"></slot>
      </span>
        </div>
        <slot name="body"></slot>
    </div>
</template>
<script>
    export default {
        name: "box",
        props: ["title"]
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .box {
        border: 1px solid $lightGray;
        margin-top: 20px;

        .btns {
            display: inline-block;
            height: 100%;
        }

        i[class*="el-icon"] {
            font-size: 20px;
            vertical-align: top;
        }

        .box-title {
            font-size: 14px;
            text-align: left;
            // background: $lightGray;
            vertical-align: middle;
            padding: 10px;
            border: 0;
            border-bottom: 1px solid $lightGray;
            position: relative;
            font-weight: bolder;
            word-wrap: normal;
            word-break: break-all;

            .inner-title {
                display: inline-block;
                height: 100%;
                margin-left: 10px;
                padding: 1px;
                box-sizing: border-box;
                color: $dominantHue;
            }

            .el-button {
                height: 30px;
                & span {
                    display: inline-block;
                    height: 100%;
                    width: 100%;
                    line-height: 4px;
                    vertical-align: top;
                }
            }

            .btns {
                position: absolute;
                right: 10px;
                top: 5px;
            }
        }

        .el-icon-s-unfold {
            color: $dominantHue;
            vertical-align: middle;
        }

        .normal-img {
            vertical-align: middle;
            text-align: center;

            & > img {
                width: 300px;
            }
        }

        .bigger-img {
            vertical-align: middle;
            text-align: center;

            & > img {
                width: 600px;
            }
        }

        .el-vue-amap-container {
            margin: 0 auto;
        }

    }
</style>


